import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const BarCompany = {
  label: "健康指數",
  key: "BarCompany",
  path: "HealthAnalysisManagement/BarCompany",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.HealthAnalysisManagement.BarCompany {...options} />
  ),
  // isBarStack: true,
  leftYDomain: [0, 100],
  xKey: "type",
  barUnit: "%",
  barColumns: [
    {
      key: "aa",
      label: "健康指數",
      ui: "bar",
    },
  ],
  columns: [],
};
